export default "__VITE_ASSET__07919028__"